import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useToast } from '../../components/Toast';
import { worksheetFaq } from '../../data/support/worksheetFaq';
import { SupportFaqList, SupportGuideLayout, SupportHelpFooter, openChannelTalk } from './SupportGuide';

export const WORKSHEET_CHAT_PATH = '/chat?category=worksheet_gen';

const CAPABILITIES = [
  { title: '객관식·서술형·OX 문제', body: '정답과 풀이까지 같이 나와요' },
  { title: '수행평가와 루브릭', body: '평가 기준표를 함께 만들어요' },
  { title: '한글(HWP)·워드 파일', body: '학교 양식 그대로 받아서 고쳐 써요' },
  { title: 'PDF로 비슷한 문제 만들기', body: '기존 시험지를 올리면 새 문제를 만들어요', pro: true },
];

const WorksheetPage = () => {
  const { showToast } = useToast();

  return (
    <>
      <Helmet>
        <title>AI 학습지 만들기 가이드 | 왓퀴즈</title>
        <meta name="description" content="학년·과목·문제 수만 적으면 AI가 학습지와 정답을 만들어요. 객관식·서술형·수행평가, 한글(HWP)·워드 파일까지 안내해요." />
        <meta name="keywords" content="AI 학습지 제작, AI 시험지, 수행평가 자료, HWP 변환, 교사 AI 학습지" />
        <meta property="og:title" content="AI 학습지 만들기 가이드 | 왓퀴즈" />
        <meta property="og:description" content="학년·과목·문제 수만 적으면 AI가 학습지와 정답을 만들어요." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://whatquiz.co.kr/support/worksheet" />
      </Helmet>

      <SupportGuideLayout current="학습지 만들기">
        <section className="sg__hero">
          <h1>학습지, 채팅으로 바로 만들어요</h1>
          <p>학년·과목·문제 수만 적으면 문제와 정답이 같이 나와요</p>
          <Link to={WORKSHEET_CHAT_PATH} className="sg__cta">무료로 학습지 만들어보기</Link>
        </section>

        <section className="sg__card" aria-label="만들어지는 예시">
          <p className="sg__label">이렇게 요청하면</p>
          <p className="sg__ask">중2 일차함수 기울기 문제 5개, 난이도 중으로 만들어줘</p>
          <p className="sg__label">이렇게 나와요</p>
          <div className="sg__answer">
            <p><b>1.</b> 일차함수 y = 2x + 3 의 그래프의 기울기는?</p>
            <p className="sg__choices">① 1　② 2　③ 3　④ 5</p>
            <p className="sg__more">… 5번까지, 정답과 풀이도 함께</p>
          </div>
        </section>

        <section className="sg__card">
          <h2>만들 수 있는 것</h2>
          <ul className="sg__list">
            {CAPABILITIES.map((item) => (
              <li key={item.title}>
                <b>
                  {item.title}
                  {item.pro && <span className="sg__pro">PRO</span>}
                </b>
                <span>{item.body}</span>
              </li>
            ))}
          </ul>
        </section>

        <section className="sg__card">
          <h2>자주 묻는 질문</h2>
          <SupportFaqList faqs={worksheetFaq} />
        </section>

        <SupportHelpFooter text="원하는 대로 안 나오면" onChat={() => openChannelTalk(showToast)} />
      </SupportGuideLayout>
    </>
  );
};

export default WorksheetPage;
